import * as React from 'react';

const SvgTooltip = (props) => (
  <svg
    width={16}
    height={16}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#tooltip_svg__a)' fill='#333'>
      <path d='M6.698 5.487a1.339 1.339 0 1 1 2.277 1.305l-.612.7A3.487 3.487 0 0 0 7.5 9.79V10a.5.5 0 0 0 1 0v-.211c0-.602.219-1.184.615-1.638l.613-.7c.728-.832.774-2.06.11-2.943-1.131-1.51-3.492-1.127-4.089.663l-.223.67a.5.5 0 1 0 .948.317l.224-.67Z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 .833a7.167 7.167 0 1 0 0 14.334A7.167 7.167 0 0 0 8 .833ZM1.833 8a6.167 6.167 0 1 1 12.334 0A6.167 6.167 0 0 1 1.833 8Z'
      />
      <path d='M8.667 12a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0Z' />
    </g>
    <defs>
      <clipPath id='tooltip_svg__a'>
        <path fill='#fff' d='M0 0h16v16H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgTooltip;
